import * as Dom from "./dom";
import * as Display from "./display";
import * as Events from "./events";
import * as Data from "./data";
import { ApiConnectionError, apiAvailability, apiConnectionError } from "./services/availability";
import { DayOfWeek } from "./entities";

declare global {
  interface Window {
    fleetoraClient: unknown;

    Dom: unknown;
    Display: unknown;
    Events: unknown;
    Data: unknown;
  }
}

async function main() {
  Display.addLoading();

  try {
    await Data.load();

    if (Data.cachedSnapshot) {
      console.info(`Cached snapshot is ${Data.cachedSnapshot.age} seconds old, day of week is ${DayOfWeek[Data.cachedSnapshot.dayOfWeek]}`);
    }
  } catch (err) {
    console.error("Failed to load data", err);

    Display.setLoadingMessage(err instanceof ApiConnectionError ? `❌ ${err.message}` : "❌ Selhalo načítání dat, zkus to znovu později");
    return;
  }

  Display.removeLoading();

  let acVehicles = Data.vehicles.filter((x) => x.isAirConditioned);
  let trackVehicles = Data.vehicles.filter((x) => x.nextStopName);
  let delayedVehicles = trackVehicles.filter((x) => x.delayMinutes);
  let totalDelay = delayedVehicles.map((x) => x.delayMinutes).reduce((result, a) => result + a, 0) * 60;

  let acPercentage = Data.vehicles.length ? Math.round((acVehicles.length / Data.vehicles.length) * 100) : 0;
  let averageDelay = trackVehicles.length ? Math.round(totalDelay / trackVehicles.length) : 0;

  Display.addVehiclesPage(acPercentage, averageDelay);
  Display.setVehicleCount(Data.vehicles.length);

  Display.renderVehicles(Data.vehicles);

  Display.addDisclaimer();
}

function registerGlobals() {
  window.fleetoraClient = Data.fleetoraClient;

  window.Dom = Dom;
  window.Display = Display;
  window.Events = Events;
  window.Data = Data;
}

function handleApiAvailabilityChange() {
  Display.setApiConnectionError(apiConnectionError);
}

function handleRetry() {
  window.location.reload();
}

apiAvailability.addEventListener("change", handleApiAvailabilityChange);
Dom.retryApi.onclick = handleRetry;

registerGlobals();
main();
